import { useParams } from 'react-router-dom';
import { all } from '../data/all';

function GenericThirdLevel() {
    const { country, first, second, third } = useParams();

    let countryData = [];
    
    all.forEach(thisCountry => {
        if (thisCountry.name.common === country) {
            countryData = JSON.stringify(thisCountry[first][second][third]);
        }
    })    

    return(
        <code>
            { countryData }
        </code>
    )
}

export default GenericThirdLevel;